(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(49821);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50744);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70082);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56168);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99731);
/* harmony import */ var _enums_playlistType__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54071);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17651);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22135);
/* harmony import */ var _typings_api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81962);
/* harmony import */ var _AppLink_AppLink__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3245);
/* harmony import */ var components_DramoxImage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20010);













var CategorySection = function(param) {
    var title = param.title, plays = param.plays, theater = param.theater, playlistType = param.playlistType, id = param.id, moreHref = param.moreHref, _showResume = param.showResume, showResume = _showResume === void 0 ? false : _showResume, _mediumThumbs = param.mediumThumbs, mediumThumbs = _mediumThumbs === void 0 ? false : _mediumThumbs, _largeThumbs = param.largeThumbs, largeThumbs = _largeThumbs === void 0 ? false : _largeThumbs, _centered = param.centered, centered = _centered === void 0 ? false : _centered;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_5__/* .Namespace.Common */ .l.Common).t;
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_2__/* .useLang */ .J)().locale;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), elementTop = ref1[0], setElementTop = ref1[1];
    var query = {};
    if (playlistType !== _enums_playlistType__WEBPACK_IMPORTED_MODULE_6__/* .PlaylistType.Theater */ .e.Theater) {
        if (id) {
            query["id"] = id;
        }
        query["type"] = playlistType;
    }
    (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useCategoryRowSwiper */ .jR)(ref, plays);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        var width = 256;
        var height = 144;
        if (mediumThumbs) {
            height = 351;
        } else if (largeThumbs) {
            width = 367;
            height = 504;
        }
        return [
            width,
            height,
            height > width
        ];
    }, [
        largeThumbs,
        mediumThumbs
    ]), imageWidth = ref2[0], imageHeight = ref2[1], isImagePortrait = ref2[2];
    var cls = [
        "category-section"
    ];
    if (mediumThumbs) {
        cls.push("category-section-medium");
    } else if (largeThumbs) {
        cls.push("category-section-large");
    }
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            var ref1;
            // calculate top only once on initial render
            setElementTop(ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.getBoundingClientRect().top);
        }
    }, [
        ref
    ]);
    var loadImages = (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useOnScrollElement */ .Vq)(elementTop);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("category-section-bg", centered ? "centered" : null),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: cls.join(" "),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    children: [
                        title,
                        Boolean(moreHref) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            href: {
                                pathname: moreHref
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: t("more")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    ref: ref,
                    className: "scroll-wrapper",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "play-list swiper-wrapper",
                            children: plays === null || plays === void 0 ? void 0 : plays.map(function(play) {
                                var ref, ref1;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("swiper-slide", showResume ? "resume" : "", play.is_original ? "original" : null),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            href: _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.play */ .xm.play(play, locale),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "category-image",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_DramoxImage__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                            loadImmediately: loadImages,
                                                            placeholderClass: "img-placeholder-category-playlist",
                                                            src: play.poster_url,
                                                            alt: play.title,
                                                            width: imageWidth,
                                                            height: imageHeight,
                                                            quality: 90,
                                                            usePlaceholder: true
                                                        })
                                                    }),
                                                    play.state === _typings_api__WEBPACK_IMPORTED_MODULE_9__/* .PlayState.PROMOTED */ .QT.PROMOTED ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "coming-soon",
                                                        children: t("coming_soon")
                                                    }) : null,
                                                    !isImagePortrait && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                children: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .truncateTitle */ .ew)(play.title)
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: theater ? theater : play.theatre.name
                                                            })
                                                        ]
                                                    }),
                                                    isImagePortrait && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                                children: [
                                                                    play.logo_url && largeThumbs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: play.logo_url,
                                                                        alt: play.title
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        children: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .truncateTitle */ .ew)(play.title)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                children: theater ? theater : play.theatre.name
                                                            })
                                                        ]
                                                    }),
                                                    showResume && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            style: {
                                                                width: "".concat(((ref = play.video) === null || ref === void 0 ? void 0 : ref.user_progress) / ((ref1 = play.video) === null || ref1 === void 0 ? void 0 : ref1.runtime) * 100, "%")
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        showResume && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "play",
                                            title: t("common:play_btn"),
                                            onClick: function() {
                                                window.location.href = _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.watch */ .xm.watch(play, locale);
                                            }
                                        })
                                    ]
                                }, play.id);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "#",
                            className: "control prev",
                            title: t("common:previous_play"),
                            children: t("common:previous_play")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "#",
                            className: "control next",
                            title: t("common:next_play"),
                            children: t("common:next_play")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategorySection);


/***/ }),

/***/ 42506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ HomeSkeleton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50744);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56168);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60950);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46323);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67129);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var HomeSkeleton = function(param) {
    var countryCode = param.countryCode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        countryCode: countryCode,
        allowPopups: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().welcome),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_5__/* .SkeletonTheme */ .y, {
                baseColor: "#22222E",
                highlightColor: "#2D2D3A",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().action)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().heading)),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().h1)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().p)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().theaters), "theaters", "swipe-theater"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("swiper-wrapper"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    width: 673,
                                    height: 70
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    width: 300,
                                    height: 70
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().fromTopGradient)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().imgTiles)),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().imgCol)),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().imgTile)),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    height: 270
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().imgTile)),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    height: 270
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().imgCol)),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().imgTile)),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    height: 270
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().imgTile)),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    height: 270
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 14460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ FeaturedSectionType; }
/* harmony export */ });
var FeaturedSectionType;
(function(FeaturedSectionType) {
    FeaturedSectionType["BANNER"] = "BANNER";
    FeaturedSectionType["CUSTOM"] = "CUSTOM";
    FeaturedSectionType["GENRE"] = "GENRE";
    FeaturedSectionType["POPULAR"] = "POPULAR";
    FeaturedSectionType["WATCHING"] = "WATCHING";
    FeaturedSectionType["NEWEST"] = "NEWEST";
    FeaturedSectionType["CUSTOM_MEDIUM"] = "CUSTOM_MEDIUM";
    FeaturedSectionType["ORIGINALS"] = "ORIGINALS";
    FeaturedSectionType["WATCHLIST"] = "WATCHLIST";
})(FeaturedSectionType || (FeaturedSectionType = {}));


/***/ }),

/***/ 49821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50744);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56168);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62044);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(36697);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46323);
/* harmony import */ var enums__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39933);
/* harmony import */ var components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66893);
/* harmony import */ var components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3245);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17651);
/* harmony import */ var helpers_jsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28808);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22135);
/* harmony import */ var components_DramoxImage__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(20010);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(52662);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(75332);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var components_HomeSkeleton__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(42506);
/* harmony import */ var constants_ui__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(73684);
/* harmony import */ var enums_FeaturedSectionType__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14460);
/* harmony import */ var components_CategorySections_CategorySection__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(74107);
/* harmony import */ var next_translate_Trans__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(46834);
/* harmony import */ var helpers_storageHelper__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(38869);

// @ts-ignore





















var Welcome = function(param) {
    var theatres = param.theatres, theatresTotalCount = param.theatresTotalCount, plays = param.plays, libraryPlays = param.libraryPlays, priceMonthly = param.priceMonthly, priceYearly = param.priceYearly, priceYearlyDiscount = param.priceYearlyDiscount, priceYearlyNoDiscount = param.priceYearlyNoDiscount, locale = param.locale, userSessionExists = param.userSessionExists, countryCode = param.countryCode, sections = param.sections;
    var ref = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(enums__WEBPACK_IMPORTED_MODULE_6__/* .Namespace.Welcome */ .lS.Welcome).t;
    var ref1 = (0,context__WEBPACK_IMPORTED_MODULE_13__/* .useAuth */ .aC)(), isUserLoaded = ref1.isUserLoaded, user = ref1.user;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("monthly"), checked = ref2[0], setChecked = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), didScrollToContent = ref3[0], setDidScrollToContent = ref3[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_14__.useRouter)();
    (0,hooks__WEBPACK_IMPORTED_MODULE_11__/* .useWelcomeTheatresRow */ ._Q)(ref, theatres, true);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isUserLoaded && user) {
            router.replace(helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.collection */ .xm.collection(locale));
        }
    }, [
        isUserLoaded,
        user
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var handleScroll = function() {
            setDidScrollToContent(window.scrollY > 370);
        };
        var debounceScroll = (0,helpers__WEBPACK_IMPORTED_MODULE_9__/* .debounce */ .Ds)(handleScroll);
        document.documentElement.classList.add(constants_ui__WEBPACK_IMPORTED_MODULE_20__/* .homeCls */ .lC);
        if (window) {
            window.addEventListener("scroll", debounceScroll, false);
            return function() {
                window.removeEventListener("scroll", debounceScroll, false);
                document.documentElement.classList.remove(constants_ui__WEBPACK_IMPORTED_MODULE_20__/* .homeCls */ .lC, constants_ui__WEBPACK_IMPORTED_MODULE_20__/* .homeContentCls */ .fk);
            };
        }
    }, []);
    var userRelatedCountryCode = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return countryCode;
    }, [
        countryCode
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        document.documentElement.classList[didScrollToContent ? "add" : "remove"](constants_ui__WEBPACK_IMPORTED_MODULE_20__/* .homeContentCls */ .fk);
    }, [
        didScrollToContent
    ]);
    if (userSessionExists && !isUserLoaded) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_HomeSkeleton__WEBPACK_IMPORTED_MODULE_15__/* .HomeSkeleton */ .G, {
            countryCode: countryCode
        });
    } else if (isUserLoaded && !user) {
    // intentional empty if - do nothing
    } else if (user) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_7__/* .BrowseSkeleton */ .C_, {
            countryCode: countryCode
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().wrapper), (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().visible)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            countryCode: countryCode,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                    children: (0,helpers_jsx__WEBPACK_IMPORTED_MODULE_10__/* .basicSEO */ .F)(t("seo:welcome_title"), t("seo:welcome_description"))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().welcome)),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().action)),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().heading)),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            children: t("welcome_title_".concat(countryCode))
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: t("welcome_subtitle_".concat(countryCode))
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().buttons),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    href: helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.registerStep1 */ .xm.registerStep1(locale),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("btn", "btn-primary"),
                                                        "data-register": "true",
                                                        "data-register-from": "welcome/first",
                                                        children: t((0,helpers__WEBPACK_IMPORTED_MODULE_9__/* .getNoTrialTranslationKeyIfNeeded */ .jU)("welcome_button_long_".concat(countryCode), userRelatedCountryCode))
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    href: helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.collection */ .xm.collection(locale),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("btn", "btn-outline-info"),
                                                        children: t("welcome_button_browse_".concat(countryCode))
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().subscriptionInfo)),
                                            children: t("welcome_price_".concat(countryCode), {
                                                monthly: priceMonthly
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().thumb),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().videoContainer),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                                playsInline: true,
                                                loop: true,
                                                autoPlay: true,
                                                muted: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                                    src: "https://42.dramoxtv.cz/video_public/hp-main-".concat(countryCode, ".mp4"),
                                                    type: "video/mp4"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().overlay)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: t("theatres_list_title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().theaters), "theaters", "swipe-theater"),
                            ref: ref,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("swiper-wrapper"),
                                    children: [
                                        theatres.map(function(theatre) {
                                            var slug = (0,helpers__WEBPACK_IMPORTED_MODULE_9__/* .slugifyString */ .V3)(theatre.title);
                                            var title = theatre.title;
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("swiper-slide"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_DramoxImage__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                        src: theatre.poster_url,
                                                        height: 70,
                                                        width: 70,
                                                        quality: 90
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().tooltiptext)),
                                                        children: title
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                        href: helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.theatre */ .xm.theatre(theatre, locale),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            children: title
                                                        })
                                                    })
                                                ]
                                            }, theatre.id);
                                        }),
                                        theatresTotalCount > 9 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().more), "swiper-slide"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                href: helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.theatres */ .xm.theatres(locale),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                    children: [
                                                        "+",
                                                        theatresTotalCount - 9
                                                    ]
                                                })
                                            })
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: t("new_welcome_sec_1_title_".concat(countryCode))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().sections),
                            children: sections.map(function(s) {
                                var title = s.name;
                                switch(s.type){
                                    case enums_FeaturedSectionType__WEBPACK_IMPORTED_MODULE_16__/* .FeaturedSectionType.POPULAR */ .T.POPULAR:
                                        title = t("common:most_popular");
                                        break;
                                    case enums_FeaturedSectionType__WEBPACK_IMPORTED_MODULE_16__/* .FeaturedSectionType.WATCHING */ .T.WATCHING:
                                        title = t("common:currently_watching");
                                        break;
                                    case enums_FeaturedSectionType__WEBPACK_IMPORTED_MODULE_16__/* .FeaturedSectionType.NEWEST */ .T.NEWEST:
                                        title = t("common:recently_added");
                                        break;
                                    case enums_FeaturedSectionType__WEBPACK_IMPORTED_MODULE_16__/* .FeaturedSectionType.ORIGINALS */ .T.ORIGINALS:
                                        break;
                                    case enums_FeaturedSectionType__WEBPACK_IMPORTED_MODULE_16__/* .FeaturedSectionType.WATCHLIST */ .T.WATCHLIST:
                                        title = t("common:watch_list");
                                        break;
                                }
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CategorySections_CategorySection__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    playlistType: enums__WEBPACK_IMPORTED_MODULE_6__/* .PlaylistType.Section */ .eX.Section,
                                    title: title,
                                    plays: s.plays,
                                    showResume: s.type === enums_FeaturedSectionType__WEBPACK_IMPORTED_MODULE_16__/* .FeaturedSectionType.WATCHING */ .T.WATCHING,
                                    mediumThumbs: s.type === enums_FeaturedSectionType__WEBPACK_IMPORTED_MODULE_16__/* .FeaturedSectionType.CUSTOM_MEDIUM */ .T.CUSTOM_MEDIUM,
                                    largeThumbs: s.type === enums_FeaturedSectionType__WEBPACK_IMPORTED_MODULE_16__/* .FeaturedSectionType.ORIGINALS */ .T.ORIGINALS,
                                    centered: true
                                }, s.id);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().subscription),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().info),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: t("welcome_subscription_title_".concat(countryCode))
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: t("welcome_subscription_1_".concat(countryCode))
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: t("welcome_subscription_2_".concat(countryCode))
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: t("welcome_subscription_3_".concat(countryCode))
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().buy),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                            type: "radio",
                                                            name: "subscription",
                                                            value: "monthly",
                                                            onChange: function() {
                                                                return setChecked("monthly");
                                                            },
                                                            checked: checked === "monthly"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                                    i18nKey: "welcome:welcome_subscription_button_1_".concat(countryCode),
                                                                    values: {
                                                                        priceMonthly: priceMonthly
                                                                    },
                                                                    components: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {}),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                            type: "radio",
                                                            name: "subscription",
                                                            value: "yearly",
                                                            onChange: function() {
                                                                return setChecked("yearly");
                                                            },
                                                            checked: checked === "yearly"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                                    i18nKey: "welcome:welcome_subscription_button_2_".concat(countryCode),
                                                                    components: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {}),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("s", {})
                                                                    ],
                                                                    values: {
                                                                        priceYearly: priceYearly,
                                                                        beforeYearly: priceYearlyNoDiscount
                                                                    }
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            type: "button",
                                            className: "btn btn-primary",
                                            onClick: function() {
                                                helpers_storageHelper__WEBPACK_IMPORTED_MODULE_19__/* ["default"].add */ .Z.add(enums__WEBPACK_IMPORTED_MODULE_6__/* .StorageKeys.HOMEPAGE_PLAN_TYPE */ .BU.HOMEPAGE_PLAN_TYPE, checked);
                                                router.push(helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.registerStep1 */ .xm.registerStep1(locale));
                                            },
                                            children: t("welcome:welcome_subscription_button_activate_".concat(countryCode))
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().note),
                                            children: t("welcome:welcome_subscription_cancel_note_".concat(countryCode))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().section)),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().pic)),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().illustration),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: t("new_welcome_sec_3_title_".concat(countryCode))
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: t("new_welcome_sec_3_text_".concat(countryCode))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            role: "img",
                                            "aria-label": t("welcome_subtitle_".concat(countryCode)),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().videoContainerBottom),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                                        playsInline: true,
                                                        loop: true,
                                                        autoPlay: true,
                                                        muted: true,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                                            src: "https://42.dramoxtv.cz/video_public/hp-bottom-".concat(countryCode, ".mp4"),
                                                            type: "video/mp4"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().mockup),
                                                    srcSet: "/webp/imgtv_".concat(countryCode, "_1x.webp 1x, /webp/imgtv_").concat(countryCode, "_2x.webp 2x"),
                                                    src: "/webp/imgtv_".concat(countryCode, "_1x.webp"),
                                                    width: 1170,
                                                    height: 820
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().overlay),
                                                    srcSet: "/webp/tv_overlay_1x.webp 1x, /webp/tv_overlay_2x.webp 2x",
                                                    src: "/webp/tv_overlay_1x.webp",
                                                    width: 1170,
                                                    height: 418
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().streamingTitle),
                                    children: t("welcome_subtitle_".concat(countryCode))
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().streaming),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().samsung),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                href: helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.howToWatchSmartTVSamsung */ .xm.howToWatchSmartTVSamsung(locale),
                                                children: t("smart-tv:samsung_title")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().lg),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                href: helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.howToWatchSmartTVLG */ .xm.howToWatchSmartTVLG(locale),
                                                children: t("smart-tv:lg_title")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().apple),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                href: helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.howToWatchMobileIOS */ .xm.howToWatchMobileIOS(locale),
                                                children: t("mobile-apps:ios_title")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().androidTv),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                href: helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.howToWatchAndroidTv */ .xm.howToWatchAndroidTv(locale),
                                                children: t("mobile-apps:android_tv_title")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().android),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                href: helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.howToWatchMobileIOS */ .xm.howToWatchMobileIOS(locale),
                                                children: t("mobile-apps:android_title")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    href: helpers__WEBPACK_IMPORTED_MODULE_9__/* .Permalink.registerStep1 */ .xm.registerStep1(locale),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("btn", "btn-primary"),
                                        "data-register": "true",
                                        "data-register-from": "welcome/first",
                                        children: t((0,helpers__WEBPACK_IMPORTED_MODULE_9__/* .getNoTrialTranslationKeyIfNeeded */ .jU)("welcome_button_long_".concat(countryCode), userRelatedCountryCode))
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().fromTopGradient)),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_21___default().faq)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        children: t("menu_faq")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        id: "faq",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_7__/* .FAQList */ .Vv, {
                                            type: "short",
                                            priceMonthly: priceMonthly,
                                            priceYearly: priceYearly,
                                            priceYearlyDiscount: priceYearlyDiscount,
                                            countryCode: countryCode
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Welcome);


/***/ }),

/***/ 67129:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h1":"HomeSkeleton_h1__j4Bem","p":"HomeSkeleton_p__lWBgW","wrapper":"HomeSkeleton_wrapper__s80JM","visible":"HomeSkeleton_visible__o5_wu","welcome":"HomeSkeleton_welcome__DrZ4F","action":"HomeSkeleton_action__V_Wnw","heading":"HomeSkeleton_heading__oYw_4","subscriptionInfo":"HomeSkeleton_subscriptionInfo__roQ6s","secMargin":"HomeSkeleton_secMargin__27b5V","section":"HomeSkeleton_section__1r3PN","info":"HomeSkeleton_info__1YL9M","reverse":"HomeSkeleton_reverse__q0miY","theaters":"HomeSkeleton_theaters__kq_fE","tooltiptext":"HomeSkeleton_tooltiptext__K2sPZ","imgTiles":"HomeSkeleton_imgTiles__GNnHG","imgCol":"HomeSkeleton_imgCol__qs8uu","imgTile":"HomeSkeleton_imgTile__zK9z3"};

/***/ }),

/***/ 36697:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__08TqZ","visible":"index_visible__WgCbJ","welcome":"index_welcome__AzUaE","action":"index_action__34b4i","heading":"index_heading__b7Ury","subscriptionInfo":"index_subscriptionInfo__ub1iI","buttons":"index_buttons__9H02R","fromTopGradient":"index_fromTopGradient__b3wbb","section":"index_section__dCy_m","pic":"index_pic__tEzjn","illustration":"index_illustration__u1eSL","overlay":"index_overlay__4m7iO","reverse":"index_reverse__jSOBX","info":"index_info__VXeMP","theaters":"index_theaters__hL_gN","more":"index_more__pabUO","tooltiptext":"index_tooltiptext__7yzVl","faq":"index_faq__eIkx0","try":"index_try__YWPOj","tryDramox":"index_tryDramox__HwUPA","landing":"index_landing__23N4r","thumb":"index_thumb__iuc13","videoContainer":"index_videoContainer__RDWXh","subscription":"index_subscription__S7kuB","buy":"index_buy__dRKpx","note":"index_note__WsrgH","streaming":"index_streaming__hxmUs","samsung":"index_samsung__w6aQD","lg":"index_lg__n1ezd","apple":"index_apple__7vBxo","android":"index_android__6pEWQ","androidTv":"index_androidTv__KHFii","streamingTitle":"index_streamingTitle__WMWH9","sections":"index_sections__Sj90r","videoContainerBottom":"index_videoContainerBottom__ZBG2O"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);